import styled from 'styled-components';
import { BackTop } from 'antd';
import { UpOutlined } from '@ant-design/icons';
import { colors } from './theme/colors';

export const StyledBackTop = styled(BackTop)`
  && {
    bottom: 40px;
    right: 40px;
    z-index: 9999;
  }
`;

export const FABButton = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: ${colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(220, 20, 60, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
  pointer-events: auto;

  &:hover {
    background-color: ${colors.primaryDark};
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(220, 20, 60, 0.6);
  }
`;

export const FABIcon = styled(UpOutlined)`
  font-size: 20px;
  color: ${colors.white};
`;
